import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getExportAssetsRules } from '@api/exportAssets';

import { EXPORT_ASSET_RULES } from '@constants/queryKeys';

export const useQueryExportAssetsRules = () => {
	const {
		accessPermission: {
			assetOwnerOrganizationAdministrator,
		},
	} = useAppSelector(auth);

	const {
		data: exportAssetsRules,
		isInitialLoading,
	} = useQuery({
		queryKey: [EXPORT_ASSET_RULES],
		queryFn: getExportAssetsRules,
		enabled: [assetOwnerOrganizationAdministrator],
		refetchOnWindowFocus: false,
	});

	return {
		exportAssetsRules,
		isInitialLoading,
	};
};
